export var wixP = function (wixParam, isMobile) {
    return isMobile ? "".concat(wixParam, "-mobile") : wixParam;
};
export var wixPMobile = function (wixParam) { return wixP(wixParam, true); };
//# sourceMappingURL=wix-params-utils.js.map